const messages = {
  title: "Übersicht über Gutscheincodes",
  short_description:
    "Hier finden Sie eine Übersicht aller eingelösten Gutscheincodes.",
  table: {
    headers: {
      voucher: "Gutscheincode",
      company: "Unternehmen",
      street: "Strasse",
      postcode: "Postleitzahl",
      location: "Ort",
      solved_at: "Einlösdatum",
      points: "Punkte durch den Code",
    },
  },
  exchange: {
    title: "Geben Sie Ihren Code ein, um Punkte zu erhalten",
    pointsLabel: "Geben Sie hier den Code ein:",
    result: "Anzahl der Punkte:",
  },
};

export default {
  messages,
};
